import {
  getPaymentGetPayUrl,
  getPaymentGetWalletURL,
  postPaymentGetGroupPurchasePayUrl,
  postPaymentGetGroupPurchaseWalletURL,
} from "api"
import { checkout, purchase } from "common/analytics"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import { useRouter } from "next/router"
import { useEffect } from "react"
import {
  isChrome,
  isEdge,
  isFirefox,
  isOpera,
  isSafari,
} from "react-device-detect"
import styled from "styled-components"
import { PaymentSteps } from "~/pages/payment"
import { usePaymentContext } from "./PaymentContext"

const StyledIFrame = styled.iframe<{ allowpaymentrequest: boolean }>`
  width: 100%;
  height: 620px;
  margin-top: 30px;
  border: none;
  ${(p) => p.theme.breakpoints.down("sm")} {
    height: 850px;
  }
`

type PaymentLinkProps = {
  type: string
  flow: "regular" | "groupPurchase" | "quickPurchase"
}

const PaymentLink = ({ type, flow }: PaymentLinkProps) => {
  const {
    orderId,
    selectedGiftCard,
    giftCardPrice,
    purchaseData,
    groupPurchaseData,
    groupPurchaseUserGuid,
  } = usePurchaseContext()
  const { iframeLink, setIframeLink, setPaymentSteps } = usePaymentContext()
  const router = useRouter()
  const isGroupPurchase = router.pathname.includes("groupPurchases")

  useEffect(() => {
    const messegeHandler = (event) => {
      // listen to messages from adi-lehamim iframe
      if (event?.data?.messageName !== "adi-lehamim") return
      // if success
      if (event?.data?.success === "True") {
        localStorage.removeItem("imageAiGuid")

        localStorage.removeItem("imageAiUrl")

        localStorage.removeItem("slugAi")
        localStorage.removeItem("sessionId")
        if (isGroupPurchase) {
          // clean states
          setIframeLink("")

          // update payment steps
          router.push("/groupPurchases/payment")
          setPaymentSteps(PaymentSteps.SUCCESS)
        } else {
          // prepare product data
          const productData = {
            name: selectedGiftCard.name,
            id: selectedGiftCard.id,
            price: giftCardPrice,
            brand: "McDonalds",
            category: "GiftCard",
            quantity: purchaseData.quantity,
          }
          // prepare action field
          const actionField = {
            id: event?.data?.TxId, // transaction id
            revenue: event?.data?.Total, // Total transaction value (incl. tax and shipping)
            tax: "",
            shipping: 0,
            coupon: "",
          }
          // track purchase
          purchase(productData, actionField, () => {
            // clean states
            setIframeLink("")

            // update payment steps
            if (isGroupPurchase || flow === "groupPurchase")
              router.push("/groupPurchases/payment")
            if (flow === "quickPurchase") router.push("/quick-purchase/payment")
            if (flow === "regular") router.push("/payment")

            setPaymentSteps(PaymentSteps.SUCCESS)
            // remove order from localStorage
            localStorage.removeItem("order")
          })
          // track checkout
          checkout(2, productData)
        }

        return
      }

      if (
        event?.data?.success === "False" &&
        event?.data?.errorCode === "2000"
      ) {
        isGroupPurchase
          ? router.push("/groupPurchases/payment")
          : router.push("/payment")
        setPaymentSteps(PaymentSteps.BLOCKED)
        return
      }
      // update payment steps
      isGroupPurchase
        ? router.push("/groupPurchases/payment")
        : router.push("/payment")
      setPaymentSteps(PaymentSteps.FAIL)
      return
    }

    // listen to messages
    window.addEventListener("message", messegeHandler)
    return () => {
      // remove listener
      window.removeEventListener("message", messegeHandler)
      // clean states
      setIframeLink("")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const getIframeLink = async () => {
      try {
        if (type === "creditCard") {
          if (isGroupPurchase) {
            const response = await postPaymentGetGroupPurchasePayUrl({
              groupPurchaseUserGuid,
              amount: groupPurchaseData.price,
              browser: isChrome
                ? "chrome"
                : isSafari
                ? "safari"
                : isFirefox
                ? "firefox"
                : isOpera
                ? "opera"
                : isEdge
                ? "edge"
                : "other browser",
            })
            setIframeLink(response.data.body.url)
          } else {
            const response = await getPaymentGetPayUrl(
              orderId,
              isChrome
                ? "chrome"
                : isSafari
                ? "safari"
                : isFirefox
                ? "firefox"
                : isOpera
                ? "opera"
                : isEdge
                ? "edge"
                : "other browser"
            )
            setIframeLink(response.data.body)
          }
        }
        if (type === "wallet") {
          if (isGroupPurchase) {
            const response = await postPaymentGetGroupPurchaseWalletURL({
              groupPurchaseUserGuid,
              amount: groupPurchaseData.price,
              browser: isChrome
                ? "chrome"
                : isSafari
                ? "safari"
                : isFirefox
                ? "firefox"
                : isOpera
                ? "opera"
                : isEdge
                ? "edge"
                : "other browser",
            })
            setIframeLink(response.data.body.url)
          } else {
            const response = await getPaymentGetWalletURL(
              orderId,
              isChrome
                ? "chrome"
                : isSafari
                ? "safari"
                : isFirefox
                ? "firefox"
                : isOpera
                ? "opera"
                : isEdge
                ? "edge"
                : "other browser"
            )
            setIframeLink(response.data.body)
          }
        }
      } catch (error) {
        console.log(error)
        // clean states
        setIframeLink("")
        setPaymentSteps(PaymentSteps.FAILURE)
        isGroupPurchase
          ? router.push("/groupPurchases/payment")
          : router.push("/payment")
      }
    }
    getIframeLink()
  }, [])

  return (
    <>
      {iframeLink && (
        <StyledIFrame allowpaymentrequest allow="payment" src={iframeLink} />
      )}
    </>
  )
}
export default PaymentLink
